<template>
  <v-snackbar
    v-model="snackbar"
    bottom
    left
    :color="alertColor"
    :timeout="5000"
  >
    <div class="d-flex align-center">
      <BaseIcon class="mr-4" :color="iconColor">{{ alertIcon }}</BaseIcon>
      <span :class="`text-subtitle-1 ${textColor}`">
        {{ $t(alert.description) }}
      </span>
      <BaseButton
        icon
        @click.stop="snackbar = false"
        :border="false"
        class="ml-4"
      >
        <BaseIcon :color="iconColor">close</BaseIcon>
      </BaseButton>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "BaseAlert",
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: {
    alertIcon() {
      if (this.alert.type === "error") {
        return "fas fa-exclamation-triangle";
      } else if (this.alert.type === "success") {
        return "far fa-check-circle";
      } else {
        return "fas fa-info-circle";
      }
    },
    alertColor() {
      if (this.alert.type === "success") return "secondary";
      if (this.alert.type === "error") return "error";
      if (this.alert.type === "info") return "white";
      return "secondary";
    },
    textColor() {
      if (this.alert.type === "success") return "text--primary";
      if (this.alert.type === "error") return "text--white";
      if (this.alert.type === "info") return "text--primary";
      return "secondary";
    },
    iconColor() {
      if (this.alert.type === "success") return "grey darken-4";
      if (this.alert.type === "error") return "white";
      if (this.alert.type === "info") return "grey darken-4";
      return "secondary";
    }
  },
  data() {
    return {
      snackbar: true
    };
  }
};
</script>
